import { Text } from "@imminently/react/ui/core/text";
import { Box } from "@mui/material";
import { ATS_COLOURS } from "@/resources/constants";
import { useSettingsContext } from "@/pages/settings/SettingsProvider";
import get from "lodash/get";
import { getTriageFromSettings, getTriageLevelColours } from "@/util/triage";

const styles = {
  ats: {
    width: "1.5rem",
    height: "1.5rem",
    borderRadius: "0.5rem",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: "2px",
    borderStyle: "solid",
  },
};

const ATSScore = ({ score }: { score: number }) => {
  const {settings} = useSettingsContext();
  const { label, colourPalette}: any = getTriageFromSettings(score, settings);
  const colours = getTriageLevelColours(colourPalette);

  const boxStyle = {
    ...styles.ats,
    borderColor: colours.border,
    backgroundColor: colours.background,
  };
  return (
    <Box sx={boxStyle}>
      <Text bold variant="caption">
        {label}
      </Text>
    </Box>
  );
};

export default ATSScore;
